import React from 'react';
import { Target, Shield, TrendingUp, Zap, Sprout, DollarSign } from 'lucide-react';
import { motion } from 'framer-motion';
export function BenefitsSection() {
  const benefits = [{
    icon: Target,
    title: 'Claridad Total',
    desc: 'Sabrás exactamente qué hacer cada día. Sin dudas, sin improvisar.'
  }, {
    icon: Shield,
    title: 'Control Real',
    desc: 'Protege tus cultivos de plagas y enfermedades antes de que aparezcan.'
  }, {
    icon: TrendingUp,
    title: 'Continuidad',
    desc: 'Cosecha todo el año, no solo en primavera. Planificación estacional inteligente.'
  }, {
    icon: Zap,
    title: 'Seguridad',
    desc: 'Alimenta a tu familia con comida libre de agrotóxicos y venenos.'
  }, {
    icon: Sprout,
    title: 'Independencia',
    desc: 'Deja de depender 100% del supermercado y sus precios inflados.'
  }, {
    icon: DollarSign,
    title: 'Posibilidad de Ingreso',
    desc: 'Aprende a producir excedentes que podrías vender a vecinos o amigos.'
  }];
  return <section className="py-20 px-4 bg-zinc-950" data-id="element-15">
      <div className="max-w-7xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-18">
            Más que un manual, una transformación
          </h2>
          <p className="text-xl text-zinc-400" data-id="element-19">
            Esto no es motivación. Es un sistema.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-20">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className="group p-8 rounded-2xl bg-zinc-900 border border-zinc-800 hover:border-green-500/50 transition-colors duration-300" data-id="element-21">
              <div className="w-14 h-14 rounded-xl bg-green-500/10 group-hover:bg-green-500/20 flex items-center justify-center mb-6 transition-colors duration-300" data-id="element-22">
                <benefit.icon className="w-7 h-7 text-green-500" data-id="element-23" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-24">
                {benefit.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed" data-id="element-25">{benefit.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}